<template>
    <div>
        <pageCard v-if="!flag" pagename='产品中心' desc='CENTER OF PRODUTION' bg='cp-top.png' mb='首页>产品中心'/>
        <router-view />
    </div>
</template>


<script>
import pageCard from '../../components/page-card/index'
import {mapState} from 'vuex'
export default {
    components : {
        pageCard
    },
    computed:mapState({
        flag : state => state.flag
    }),
}
</script>